import { Row, Col, Divider, Select, Statistic, Space } from "antd";
import LoadMore from "../LoadMore/LoadMore";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function UserTabContent({
    countersByUser,
    currentUserId,
    currentUserIsAdmin,
    usersList,
    usersPaginatorHasNext,
    nextUsersPageCb,
}) {
    const { t } = useTranslation();
    const [selectedUserId, setSelectedUserId] = useState(currentUserId);
    function handleSelectUserChange(selectedUserId) {
        setSelectedUserId(selectedUserId);
    }
    return (
        <Space direction="vertical" style={{ display: "flex" }}>
            {currentUserIsAdmin ? (
                <div>
                    <h4 style={{ marginBottom: "0px" }}>{t("counters.chatsFromUser")}</h4>
                    <Select
                        style={{ width: "100%" }}
                        value={selectedUserId}
                        onChange={handleSelectUserChange}
                        placeholder={t("counters.selectAnAgent")}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                            option.props.children
                                .join()
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }
                        dropdownRender={(menu) => (
                            <>
                                {menu}
                                {usersPaginatorHasNext && (
                                    <>
                                        <Divider />
                                        <LoadMore onClick={nextUsersPageCb} />
                                    </>
                                )}
                            </>
                        )}
                    >
                        {usersList.map((user) => (
                            <Select.Option key={user.id} value={user.id}>
                                {user.firstName} {user.lastName}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ) : (
                <h4>{t("counters.myChats")}</h4>
            )}
            <div style={{ borderLeft: "1px solid #d6d6d6", paddingLeft: "12px" }}>
                <Row gutter={24}>
                    <Col span={12}>
                        <Statistic
                            title={t("counters.assignedChatsToUserCounter")}
                            value={countersByUser[selectedUserId]?.assignedChatsToUserCounter || 0}
                        />
                    </Col>
                    <Col span={12}>
                        <Statistic
                            title={t("counters.waitingAnswerChatsAssignedToUserCounter")}
                            value={
                                countersByUser[selectedUserId]
                                    ?.waitingAnswerChatsAssignedToUserCounter || 0
                            }
                        />
                    </Col>
                </Row>
            </div>
        </Space>
    );
}

export default UserTabContent;
